import React from "react";
import classes from "./Homepage.module.css";
import {MdOutlineVerified} from "react-icons/md";
import {IoQrCodeOutline} from "react-icons/io5";
import {FiMessageSquare} from "react-icons/fi";
import {IoVideocamOutline} from "react-icons/io5";
import ReactPlayer from "react-player";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from "react-responsive-carousel";
import EurocrossPatientFriendlyDesign from "../../assets/eurocross_patient_friendly_design.jpg";
import WhyEurocrossImage from "../../assets/why_eurocross.jpg";
import EurocrossDigitalDesign from "../../assets/eurocross_digital_design.jpg";
const Homepage = () => {
  return (
    <div className={classes.homepageDiv}>
      <div className={classes.bannerDiv}>
        <div>Pure European Quality</div>
        <div>Trusted at Every Dose</div>
        <div>Experience medications manufactured under EU-GMP certification with innovative digital verification at your fingertips.</div>
      </div>

      <div className={classes.homepageSection2}>
        <div>
          <div>
            <MdOutlineVerified />
          </div>
          <div>EU-GMP certified</div>
        </div>
        <div>
          <div>
            <IoQrCodeOutline />
          </div>
          <div>Batch Verification</div>
        </div>
        <div>
          <div>
            <FiMessageSquare />
          </div>
          <div>WhatsApp Dosage Reminders</div>
        </div>
        <div>
          <div>
            <IoVideocamOutline />
          </div>
          <div>Traceable Manufacturing Video</div>
        </div>
      </div>

      <div className={classes.homepageSection3}>
        <img src={EurocrossPatientFriendlyDesign} alt="Eurocross" />
      </div>

      <div className={classes.homepageSection4}>
        <img src={WhyEurocrossImage} alt="Eurocross" />
      </div>

      <div className={classes.digitalDesignDiv}>
        <img src={EurocrossDigitalDesign} alt="Eurocross" />
      </div>

      <div className={classes.homepageSection5}>
        <div className={classes.homepageSection5Header}>
          <div>See Our EU Manufacturing Excellence</div>
          <div>Take an exclusive tour of our state-of-the-art EU-GMP certified facilities where your medications are produced under the strictest quality controls.</div>
        </div>
        <br />
        <br />
        <div className={classes.homepagePlantVideoPlayer}>
          <ReactPlayer width="100%" height="100%" controls={true} url="https://s3.ap-south-1.amazonaws.com/data.eurocross.in/Plant%20video.mp4" />
        </div>
      </div>

      <div className={classes.homepageSection6}>
        <div>What Our Customers Say</div>
        <div className={classes.homepageSection6CarouselDiv}>
          <Carousel className={classes.homepageSection6Carousel} width={"100%"} autoPlay={false} infiniteLoop={true}>
            <div className={classes.carouselItem}>
              <div>
                <span className={classes.carouselInvitedComma}>"&nbsp;&nbsp;</span>
                <i>The QR verification gives me complete peace of mind. I know exactly what I'm taking and where it came from. Eurocross has set a new standard for medication trust.</i>
                <span className={classes.carouselInvitedComma}>&nbsp;&nbsp;"</span>
              </div>
              <div>
                <b>Anika Sharma</b>
                <br />
                <span>Mumbai, India</span>
              </div>
            </div>
            <div className={classes.carouselItem}>
              <div>
                <span className={classes.carouselInvitedComma}>"&nbsp;&nbsp;</span>
                <i>The WhatsApp reminders have been a game-changer for me. I've never been so consistent with my medication, and I've seen better results because of it.</i>
                <span className={classes.carouselInvitedComma}>&nbsp;&nbsp;"</span>
              </div>
              <div>
                <b>Rajiv Mehta</b>
                <br />
                <span>Delhi, India</span>
              </div>
            </div>
            <div className={classes.carouselItem}>
              <div>
                <span className={classes.carouselInvitedComma}>"&nbsp;&nbsp;</span>
                <i>After seeing the manufacturing video, I understand why Eurocross medications are worth the premium. The attention to detail and quality control is impressive.</i>
                <span className={classes.carouselInvitedComma}>&nbsp;&nbsp;"</span>
              </div>
              <div>
                <b>Priya Patel</b>
                <br />
                <span>Bangalore, India</span>
              </div>
            </div>
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
